import { render, staticRenderFns } from "./HomepageImage.vue?vue&type=template&id=65b12abd&"
import script from "./HomepageImage.vue?vue&type=script&lang=js&"
export * from "./HomepageImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports